var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmployeeGroupsEmptyState(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 782 496",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "employee-groups-empty-state") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "0.0043144361%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.12,
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "38508%",
    y1: "49021%",
    x2: "38508%",
    y2: "25844%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.12,
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "66123%",
    y1: "23177%",
    x2: "66123%",
    y2: "0%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.12,
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "11589%",
    y1: "48262%",
    x2: "11589%",
    y2: "25085%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.12,
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "66555%",
    y1: "49547%",
    x2: "66555%",
    y2: "26370%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.12,
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.1,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "11672%",
    y1: "74315%",
    x2: "11672%",
    y2: "51138%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.12,
    offset: "54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.1,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "employee-groups-empty-state"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.5,
    transform: "translate(0.000000, 6.000000)",
    fillRule: "nonzero",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 116.72,
    cy: 116.09,
    r: 115.89
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F5F5F5",
    fillRule: "nonzero",
    cx: 116.72,
    cy: 121.46,
    r: 113.44
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.04,235.22 C139.207739,235.256473 160.895803,228.766748 179.4,216.56 C175.22,193.72 159.31,192.41 159.31,192.41 L71.6,192.41 C71.6,192.41 56.6,193.64 51.9,214.66 C70.9700645,228.073899 93.7247959,235.255926 117.04,235.22 L117.04,235.22 Z",
    id: "Shape",
    fill: "#455A64",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#333333",
    fillRule: "nonzero",
    cx: 115.85,
    cy: 118.96,
    r: 50.29
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.18,164.57 L133.27,164.57 L133.27,192.64 C133.27,202.327075 125.417075,210.18 115.73,210.18 L115.73,210.18 C106.042925,210.18 98.19,202.327075 98.19,192.64 L98.19,164.57 L98.18,164.57 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.53,163.27 L129.92,163.27 C131.770154,163.27 133.27,164.769846 133.27,166.62 L133.27,191.34 C133.27,201.027075 125.417075,208.88 115.73,208.88 L115.73,208.88 C106.042925,208.88 98.19,201.027075 98.19,191.34 L98.19,166.62 C98.1899918,164.773744 99.6837525,163.275511 101.53,163.27 Z",
    id: "Shape",
    fill: "#BE7C5E",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.25,177.82 C109.558691,182.046642 122.007402,182.082118 133.34,177.92 L133.34,173.61 L98.25,173.61 L98.25,177.82 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#BE7C5E",
    fillRule: "nonzero",
    cx: 115.85,
    cy: 129.88,
    r: 50.29
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.38,109.14 C85.97,106.97 86.71,104.58 88.66,103.45 C90.2,102.55 92.11,102.69 93.89,102.78 C107.79,103.54 121.57,100.37 135.09,97.06 C142.82,95.17 151.09,92.87 156.09,86.64 C161.09,80.41 154.57,60.83 146.96,58.52 C141.96,56.99 136.16,59.84 131.42,57.6 C129.31,56.6 127.76,54.73 125.94,53.27 C122.21,50.27 117.42,49.06 112.78,47.92 C107.36,46.58 101.5,45.27 96.35,47.42 C92.35,49.08 89.43,52.59 85.64,54.67 C78.43,58.67 69.64,56.81 61.38,56.79 C58.59,56.79 55.26,57.35 54.15,59.91 C53.4,61.65 54,63.63 54.08,65.52 C54.32,71.52 49.37,76.19 45.22,80.52 C41.07,84.85 37.15,91.03 39.77,96.41 C40.77,98.46 42.6,100.01 43.64,102.04 C45.43,105.56 44.53,109.81 45.18,113.7 C45.8308073,116.651723 46.9338217,119.485154 48.45,122.1 C51.53,128.1 67,160.4 74.11,152.19 C77.55,148.19 78.11,136.63 79.5,131.43 C81.42,123.956667 83.38,116.526667 85.38,109.14 Z",
    id: "Shape",
    fill: "#333333",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#BE7C5E",
    fillRule: "nonzero",
    cx: 80.07,
    cy: 128.05,
    rx: 4.68,
    ry: 8.77
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.5,
    transform: "translate(269.000000, 258.000000)",
    fillRule: "nonzero",
    fill: "url(#linearGradient-2)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 116.08,
    cy: 116.32,
    r: 115.89
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F5F5F5",
    fillRule: "nonzero",
    cx: 385.3,
    cy: 373.58,
    r: 113.44
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.4,487.47 C407.554122,487.49862 429.227168,481.009226 447.72,468.81 C443.54,445.97 427.63,444.66 427.63,444.66 L339.95,444.66 C339.95,444.66 324.95,445.89 320.25,466.91 C339.322854,480.325868 362.081384,487.507992 385.4,487.47 Z",
    id: "Shape",
    fill: "#455A64",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F55F44",
    fillRule: "nonzero",
    cx: 384.2,
    cy: 371.19,
    r: 54.76
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.53,416.8 L401.62,416.8 L401.62,444.87 C401.62,454.557075 393.767075,462.41 384.08,462.41 L384.08,462.41 C374.392925,462.41 366.54,454.557075 366.54,444.87 L366.54,416.8 L366.53,416.8 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.88,415.5 L398.27,415.5 C399.158475,415.5 400.010561,415.852945 400.638808,416.481192 C401.267055,417.109439 401.62,417.961525 401.62,418.85 L401.62,443.57 C401.62,448.221897 399.772041,452.683265 396.482653,455.972653 C393.193265,459.262041 388.731897,461.11 384.08,461.11 L384.08,461.11 C379.428103,461.11 374.966735,459.262041 371.677347,455.972653 C368.387959,452.683265 366.54,448.221897 366.54,443.57 L366.54,418.85 C366.54,416.999846 368.039846,415.5 369.89,415.5 L369.88,415.5 Z",
    id: "Shape",
    fill: "#FDA57D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.6,430.05 C377.908691,434.276642 390.357402,434.312118 401.69,430.15 L401.69,425.84 L366.6,425.84 L366.6,430.05 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FDA57D",
    fillRule: "nonzero",
    cx: 384.2,
    cy: 382.11,
    r: 50.29
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F55F44",
    fillRule: "nonzero",
    cx: 384.13,
    cy: 315.49,
    r: 20.24
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F55F44",
    fillRule: "nonzero",
    cx: 384.13,
    cy: 295.56,
    r: 13.29
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.35,326.59 C365.485944,322.165355 360.840542,310.76981 364.8,300.71 C364.66,300.99 364.52,301.28 364.39,301.57 C361.430054,308.168695 362.215314,315.845254 366.449979,321.707989 C370.684645,327.570725 377.725369,330.728949 384.91998,329.992989 C392.11459,329.25703 398.370055,324.738696 401.33,318.14 C401.46,317.85 401.58,317.56 401.7,317.26 C396.81939,326.909749 385.215424,331.018478 375.35,326.59 Z",
    id: "Shape",
    fill: "#F55F44",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.39,336.37 C348.39,336.37 369.58,379.37 429.39,354.37 L415.47,332.54 L390.8,323.68 L348.39,336.37 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.39,335.73 C348.39,335.73 369.58,378.73 429.39,353.73 L415.47,331.9 L390.8,323.04 L348.39,335.73 Z",
    id: "Shape",
    fill: "#F55F44",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.72,320.07 C377.759866,319.044425 390.860134,319.044425 403.9,320.07 C403.9,320.07 374.96,322.76 364.72,320.07 Z",
    id: "Shape",
    fill: "#333333",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.17,281.46 C386.164523,281.423115 385.158104,281.500274 384.17,281.69 L384.94,281.69 C391.71789,281.906816 397.243635,287.195495 397.757261,293.957373 C398.270886,300.719251 393.607376,306.781895 386.94,308.02 C394.274341,308.086274 400.273725,302.194341 400.339999,294.86 C400.406274,287.525659 394.514341,281.526274 387.18,281.46 L387.17,281.46 Z",
    id: "Shape",
    fill: "#F55F44",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FDA57D",
    fillRule: "nonzero",
    cx: 333.9,
    cy: 382.06,
    rx: 4.68,
    ry: 8.77
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FDA57D",
    fillRule: "nonzero",
    cx: 434.49,
    cy: 382.06,
    rx: 4.68,
    ry: 8.77
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#F55F44",
    fillRule: "nonzero",
    points: "345.22 337 355.03 331.94 357.24 340.05 351.23 344.14"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.5,
    transform: "translate(545.000000, 0.000000)",
    fillRule: "nonzero",
    fill: "url(#linearGradient-3)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 116.23,
    cy: 115.89,
    r: 115.89
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F5F5F5",
    fillRule: "nonzero",
    cx: 661.45,
    cy: 115.14,
    r: 113.44
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.55,229.04 C683.717739,229.076473 705.405803,222.586748 723.91,210.38 C719.72,187.53 703.82,186.22 703.82,186.22 L616.11,186.22 C616.11,186.22 601.11,187.45 596.41,208.47 C615.478886,221.887448 638.233713,229.072999 661.55,229.04 Z",
    id: "Shape",
    fill: "#455A64",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#72351C",
    fillRule: "nonzero",
    cx: 660.36,
    cy: 112.75,
    r: 54.76
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.68,158.36 L677.77,158.36 L677.77,186.43 C677.777965,191.087093 675.933523,195.556171 672.643272,198.852051 C669.35302,202.14793 664.8871,204.000007 660.23,204 L660.23,204 C650.542925,204 642.69,196.147075 642.69,186.46 L642.69,158.36 L642.68,158.36 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646,157.06 L674.39,157.06 C676.240154,157.06 677.74,158.559846 677.74,160.41 L677.74,185.13 C677.74,194.817075 669.887075,202.67 660.2,202.67 L660.2,202.67 C650.512925,202.67 642.66,194.817075 642.66,185.13 L642.66,160.41 C642.66,158.559846 644.159846,157.06 646.01,157.06 L646,157.06 Z",
    id: "Shape",
    fill: "#FDA57D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.72,171.61 C654.028691,175.836642 666.477402,175.872118 677.81,171.71 L677.81,167.4 L642.72,167.4 L642.72,171.61 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FDA57D",
    fillRule: "nonzero",
    cx: 660.36,
    cy: 123.67,
    r: 50.29
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.54,77.93 C624.54,77.93 645.73,120.93 705.54,95.93 L691.62,74.1 L666.95,65.24 L624.54,77.93 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.54,77.3 C624.54,77.3 645.73,120.3 705.54,95.3 L691.62,73.47 L666.95,64.61 L624.54,77.3 Z",
    id: "Shape",
    fill: "#72351C",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.35,74.39 C625.778613,69.966862 628.247736,65.9511065 631.55,62.68 C641.44,52.9 657.66,50.84 665.98,39.68 C666.89416,41.2772077 667.089592,43.1867149 666.517933,44.9359911 C665.946274,46.6852674 664.660939,48.110864 662.98,48.86 C670.98,48.81 680.19,48.11 684.69,41.55 C686.96322,46.8411302 685.986139,52.968323 682.18,57.29 C689.24,57.61 696.78,62.4 697.24,69.46 C697.54,74.16 694.6,78.61 690.73,81.31 C686.86,84.01 682.2,85.22 677.6,86.22 C664.18,89.22 615.59,101.63 624.35,74.39 Z",
    id: "Shape",
    fill: "#72351C",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.65,124.11 L709.32,124.11 L683.38,147.22 C658.38,135.52 640.04,147.22 640.04,147.22 L612.84,125.08 L610.1,125.42 C610.871878,152.884131 633.54251,174.645447 661.015225,174.293023 C688.487941,173.940598 710.592889,151.604894 710.66,124.13 L710.65,124.11 Z M660.29,156.06 C650.51,156.06 642.58,154.06 642.58,151.63 C642.58,149.2 650.51,147.2 660.29,147.2 C670.07,147.2 678,149.2 678,151.63 C678,154.06 670.07,156.06 660.28,156.06 L660.29,156.06 Z",
    id: "Shape",
    fill: "#72351C",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FDA57D",
    fillRule: "nonzero",
    cx: 610.05,
    cy: 123.62,
    rx: 4.68,
    ry: 8.77
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FDA57D",
    fillRule: "nonzero",
    cx: 710.64,
    cy: 123.62,
    rx: 4.68,
    ry: 8.77
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.5,
    transform: "translate(0.000000, 250.000000)",
    fillRule: "nonzero",
    fill: "url(#linearGradient-4)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 115.89,
    cy: 116.73,
    r: 115.89
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F5F5F5",
    fillRule: "nonzero",
    cx: 116.11,
    cy: 365.99,
    r: 113.44
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.21,479.88 C138.374335,479.914509 160.058644,473.424867 178.56,461.22 C174.38,438.38 158.47,437.07 158.47,437.07 L70.72,437.07 C70.72,437.07 55.72,438.3 51.02,459.32 C70.1040133,472.743749 92.8777379,479.926258 116.21,479.88 L116.21,479.88 Z",
    id: "Shape",
    fill: "#455A64",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#333333",
    fillRule: "nonzero",
    cx: 115.01,
    cy: 363.6,
    r: 54.76
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.34,409.21 L132.43,409.21 L132.43,437.28 C132.43,446.967075 124.577075,454.82 114.89,454.82 L114.89,454.82 C110.238103,454.82 105.776735,452.972041 102.487347,449.682653 C99.197959,446.393265 97.35,441.931897 97.35,437.28 L97.35,409.21 L97.34,409.21 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.69,407.91 L129.08,407.91 C130.930154,407.91 132.43,409.409846 132.43,411.26 L132.43,436 C132.43,445.687075 124.577075,453.54 114.89,453.54 L114.89,453.54 C110.23637,453.542653 105.772433,451.695866 102.480882,448.40619 C99.1893309,445.116514 97.3399992,440.65363 97.34,436 L97.34,411.25 C97.34,409.399846 98.8398461,407.9 100.69,407.9 L100.69,407.91 Z",
    id: "Shape",
    fill: "#FDB797",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.41,422.46 C108.718691,426.686642 121.167402,426.722118 132.5,422.56 L132.5,418.22 L97.41,418.22 L97.41,422.46 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FDB797",
    fillRule: "nonzero",
    cx: 115.01,
    cy: 374.52,
    r: 50.29
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2,328.77 C79.2,328.77 100.39,371.77 160.2,346.77 L146.28,324.94 L121.61,316.08 L79.2,328.77 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2,328.14 C79.2,328.14 100.39,371.14 160.2,346.14 L146.28,324.31 L121.61,315.45 L79.2,328.14 Z",
    id: "Shape",
    fill: "#333333",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.01,325.22 C80.4386125,320.796862 82.9077363,316.781107 86.21,313.51 C96.1,303.73 112.32,301.67 120.64,290.51 C121.55416,292.107208 121.749592,294.016715 121.177933,295.765991 C120.606274,297.515267 119.320939,298.940864 117.64,299.69 C125.64,299.64 134.85,298.94 139.35,292.38 C141.62322,297.67113 140.646139,303.798323 136.84,308.12 C143.9,308.44 151.44,313.23 151.9,320.29 C152.2,324.99 149.26,329.44 145.39,332.14 C141.52,334.84 136.85,336.07 132.25,337.09 C118.83,340.07 70.25,352.48 79.01,325.22 Z",
    id: "Shape",
    fill: "#333333",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FDB797",
    fillRule: "nonzero",
    cx: 64.7,
    cy: 374.47,
    rx: 4.68,
    ry: 8.77
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FDB797",
    fillRule: "nonzero",
    cx: 165.29,
    cy: 374.47,
    rx: 4.68,
    ry: 8.77
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.5,
    transform: "translate(549.000000, 263.000000)",
    fillRule: "nonzero",
    fill: "url(#linearGradient-5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 116.55,
    cy: 116.58,
    r: 115.89
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F5F5F5",
    fillRule: "nonzero",
    cx: 665.55,
    cy: 378.95,
    r: 113.44
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.87,492.73 C688.037739,492.766473 709.725803,486.276748 728.23,474.07 C724.05,451.23 708.14,449.92 708.14,449.92 L620.42,449.92 C620.42,449.92 605.42,451.15 600.72,472.17 C619.792854,485.585868 642.551384,492.767992 665.87,492.73 Z",
    id: "Shape",
    fill: "#455A64",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647,422.06 L682.09,422.06 L682.09,450.13 C682.09,459.817075 674.237075,467.67 664.55,467.67 L664.55,467.67 C659.89637,467.672653 655.432433,465.825866 652.140882,462.53619 C648.849331,459.246514 646.999999,454.78363 647,450.13 L647,422.06 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.35,420.76 L678.74,420.76 C680.590154,420.76 682.09,422.259846 682.09,424.11 L682.09,448.83 C682.09,458.517075 674.237075,466.37 664.55,466.37 L664.55,466.37 C659.89637,466.372653 655.432433,464.525866 652.140882,461.23619 C648.849331,457.946514 646.999999,453.48363 647,448.83 L647,424.11 C647,422.259846 648.499846,420.76 650.35,420.76 L650.35,420.76 Z",
    id: "Shape",
    fill: "#FDB797",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.07,435.31 C658.378691,439.536642 670.827402,439.572118 682.16,435.41 L682.16,431.1 L647.07,431.1 L647.07,435.31 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FDB797",
    fillRule: "nonzero",
    cx: 664.67,
    cy: 387.37,
    r: 50.29
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FDB797",
    fillRule: "nonzero",
    cx: 615.42,
    cy: 385.22,
    rx: 4.68,
    ry: 8.77
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FDB797",
    fillRule: "nonzero",
    cx: 713.66,
    cy: 385.22,
    rx: 4.68,
    ry: 8.77
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    stroke: "#333333",
    strokeWidth: 2,
    x: 634.03,
    y: 387.61,
    width: 21.51,
    height: 10.76,
    rx: 4.35
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    stroke: "#333333",
    strokeWidth: 2,
    transform: "translate(684.565000, 392.980000) rotate(180.000000) translate(-684.565000, -392.980000) ",
    x: 673.81,
    y: 387.6,
    width: 21.51,
    height: 10.76,
    rx: 4.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.72,388.65 C654.72,388.65 661.54,384.95 674.22,388.65",
    id: "Shape",
    stroke: "#333333",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.44,350.92 L711.78,379.59 C711.78,379.59 726.87,360.57 699.44,350.92 Z",
    id: "Shape",
    fill: "#858585",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.32,392.99 L713.74,376.54",
    id: "Shape",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.92,350.92 L617.58,379.59 C617.58,379.59 602.49,360.57 629.92,350.92 Z",
    id: "Shape",
    fill: "#858585",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.03,392.99 L615.36,376.54",
    id: "Shape",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.5,
    transform: "translate(546.000000, 0.000000)",
    fillRule: "nonzero",
    fill: "url(#linearGradient-6)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: -161.11,
    cy: 115.89,
    r: 115.89
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F5F5F5",
    fillRule: "nonzero",
    cx: 385.44,
    cy: 115.44,
    r: 113.44
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.75,125 C447.75,166.78 420.49,213.29 386.86,213.29 C353.23,213.29 326,166.78 326,125 C326,83.22 353.26,62 386.89,62 C420.52,62 447.75,83.23 447.75,125 Z",
    id: "Shape",
    fill: "#FDD835",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.14,228.81 C408.307739,228.846473 429.995803,222.356748 448.5,210.15 C444.32,187.31 428.41,186 428.41,186 L340.7,186 C340.7,186 325.7,187.23 321,208.25 C340.070065,221.663899 362.824796,228.845926 386.14,228.81 L386.14,228.81 Z",
    id: "Shape",
    fill: "#455A64",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367,158 L402.09,158 L402.09,186.07 C402.09,195.757075 394.237075,203.61 384.55,203.61 L384.55,203.61 C374.862925,203.61 367.01,195.757075 367.01,186.07 L367.01,158 L367,158 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.34,157 L398.73,157 C400.580154,157 402.08,158.499846 402.08,160.35 L402.08,185.07 C402.08,194.757075 394.227075,202.61 384.54,202.61 L384.54,202.61 C374.852925,202.61 367,194.757075 367,185.07 L367,160.35 C366.999992,158.503744 368.493753,157.005511 370.34,157 Z",
    id: "Shape",
    fill: "#FDB797",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367,171.21 C378.308691,175.436642 390.757402,175.472118 402.09,171.31 L402.09,167 L367,167 L367,171.21 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FDB797",
    fillRule: "nonzero",
    cx: 384.29,
    cy: 123.29,
    r: 50.29
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FDB797",
    fillRule: "nonzero",
    cx: 335.68,
    cy: 120.77,
    rx: 4.68,
    ry: 8.77
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FDB797",
    fillRule: "nonzero",
    cx: 433.68,
    cy: 120.77,
    rx: 4.68,
    ry: 8.77
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,96.216239 C340,96.216239 368.43,135.126239 433.63,121.836239 C433.63,121.836239 440.91,112.976239 423.19,85.776239 C405.47,58.576239 356.13,63.006239 340,96.216239 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,95.216239 C340,95.216239 368.43,134.126239 433.63,120.836239 C433.63,120.836239 440.91,111.976239 423.19,84.776239 C405.47,57.576239 356.13,62.006239 340,95.216239 Z",
    id: "Shape",
    fill: "#FDD835",
    fillRule: "nonzero"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeGroupsEmptyState);
export default __webpack_public_path__ + "static/media/employee-groups-empty-state.6d5d800e.svg";
export { ForwardRef as ReactComponent };